import Header from "./templates/components/Header_temp";
import Services from "./templates/components/Services_temp";
import styles from "../home/Home.module.css";
import LatestProjects from "./templates/components/Latest_projects_temp";
import Experience from "./templates/components/Experience";
import NavigationBar from "../Shared/NavigationBar";
import WhyHire from "./templates/components/Why_hire";
import Reviews from "./templates/components/Reviews";
import Contact from "./templates/components/Contact";
// import Skills from "./templates/components/Skills";

function Home(props) {
  return (
    <div className={styles.home}>
      <NavigationBar />
      <Header />
      <Services />
      <LatestProjects />
      <Experience />
      {/* <Skills /> */}
      <WhyHire />
      <Reviews />
      <Contact />
    </div>
  );
}

export default Home;
